import { NeoReport, Report } from "@singularsystems/neo-reporting";
import IssuerDividendLetterCriteria from "./IssuerDividendLetterCriteria";

@NeoReport("IssuerDividendLetter", { hidden: true })
export default class IssuerDividendLetterReport extends Report<IssuerDividendLetterCriteria> {

    constructor() {
        super(IssuerDividendLetterCriteria);
    }

    public renderCriteria() {
        return <div>
        </div>;
    }
}